import { z } from 'zod';

import { baseNotificationRawSchema, baseNotificationRawSchemaParser } from './BaseNotification';

export const promotionNotificationType = z.literal('PROMOTION');

export const newsNotificationType = z.literal('NEWS');

export const publicationNotificationSchema = baseNotificationRawSchema
  .extend({
    type: z.union([promotionNotificationType, newsNotificationType]),
    extra: z.object({
      slug: z.string(),
    }),
  })
  .transform((raw) => {
    return {
      ...baseNotificationRawSchemaParser(raw),
      type: raw.type,
      extra: {
        slug: raw.extra.slug,
      },
    };
  });

export type PublicationNotificationEntityApi = z.input<typeof publicationNotificationSchema>;

export type PublicationNotificationEntity = z.infer<typeof publicationNotificationSchema>;
